import React, { useState, useEffect } from "react";

import useInterval from "@rooks/use-interval";
// import axios from "axios";
import axios from "../../../api/axios";
import LineChartComponent from "../LineChartComponent";
import SvgComponent from "../SvgComponent";
import useConfig from "../../../hooks/useConfig";
import GeneralMainMap from "../GeneralMainMap";
import YsbMainMap from "./YsbMainMap";
import "./index.css";
import ApexLineChart from "../ApexLineChartComponent";
import ApexMultiBarChart from "../ApexMultiBarChartComponent";
import CountUp from "react-countup";
import YsbBarChart from "./YsbShadBarChart";
import YsbLineChart from "./YsbShadLineChart";
import YsbRadialChart from "./YsbShadRadialChart";
import { endOfDay } from "date-fns";
import YsbDonutChart from "./YsbShadDonutChart";
import { Skeleton } from "../../ui/Skeleton";
import YsbLineChartOccupancy from "./YsbShadLineChartOccupancy";

// import InfoBox from "../../InfoBox";
// import GreenArrowUp from "../../../images/GreenArrowUp";
// import RedArrowDown from "../../../images/RedArrowDown";

var request_updateTimelineData_safe = true;

function getLocalHour(date) {
    if (date) {
        let hour = new Date(date).getHours();
        return hour < 10 ? `0${hour}:00` : `${hour}:00`;
    }
}
function findHourData(timeline, hour, device) {
    for (let i = 0; i < timeline.length; i++) {
        if (timeline[i]["hour"] === hour) {
            return { success: 1, timeline: timeline[i] };
        }
    }
    return { success: -1, hour, timeline: timeline[0], [device]: 0 };
}

// function margeSameHours(timeline) {
//   let temp = [];
//   for (let i = 0; i < timeline.length; i++) {
//     let currentChecker = timeline[i];
//     let deviceId = currentChecker["deviceId"];

//     for (let j = i + 1; j < timeline.length; j++) {
//       if (
//         parseInt(timeline[i]["hour"].split(":")[0]) ===
//           parseInt(timeline[j]["hour"].split(":")[0]) &&
//         currentChecker["deviceId"] === timeline[j]["deviceId"]
//       ) {
//         currentChecker[deviceId] =
//           currentChecker[deviceId] + timeline[j][deviceId];
//       }
//     }
//     temp.push(currentChecker);
//   }

//   return temp;
// }
function margeSameHours(timeline) {
    let hours = new Set();
    let data = [];
    for (let i = 0; i < timeline.length; i++) {
        if (i === 0) {
            hours.add(timeline[i]["hour"]);
            let currentChecker = timeline[i];
            for (let j = 1; j < timeline.length; j++) {
                if (currentChecker["hour"] === timeline[j]["hour"]) {
                    currentChecker["leaving"] += timeline[j]["leaving"];
                    currentChecker["entering"] += timeline[j]["entering"];
                    currentChecker["total"] += timeline[j]["total"];
                }
            }
            data.push(currentChecker);
        } else if (!hours.has(timeline[i]["hour"])) {
            hours.add(timeline[i]["hour"]);
            let currentChecker = timeline[i];
            for (let j = i + 1; j < timeline.length; j++) {
                if (currentChecker["hour"] === timeline[j]["hour"]) {
                    currentChecker["leaving"] += timeline[j]["leaving"];
                    currentChecker["entering"] += timeline[j]["entering"];
                    currentChecker["total"] += timeline[j]["total"];
                }
            }
            data.push(currentChecker);
        } else continue;
    }
    return data.sort(
        (a, b) =>
            new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate(),
                parseInt(a["hour"].split(".")[0])
            ) -
            new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate(),
                parseInt(a["hour"].split(".")[0])
            )
    );
}

function fillLine(timeline, devices) {
    let temp = [];
    // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    for (let j = 0; j < devices.length; j++) {
        const device = devices[j];
        for (let i = 0; i <= new Date().getHours(); i++) {
            let hour = i < 10 ? `0${i}:00` : `${i}:00`;
            let res = findHourData(timeline, hour, device);
            if (res.success !== -1) {
                temp.push(res.timeline);
            } else {
                let obj = {
                    hour: hour,
                    [device]: 0,
                    keys: res.timeline["keys"],
                };
                for (let l = 0; l < res.timeline["keys"].length; l++) {
                    const element = res.timeline["keys"][l];
                    obj[element] = 0;
                }
                temp.push(obj);
            }
        }
    }
    return temp;
}
// var request_updateTrackObjects_safe = true;

const YsbCombinedComponents = ({ token, areas, map }) => {
    // const [rest_trackObj, setRest_trackObj] = useState({});

    const [timelineData, setTimelineData] = useState([]);
    const [timelineDataTsinberi, setTimelineDataTsinberi] = useState([]);
    const [timelineDataShikmim, setTimelineDataShikmim] = useState([]);
    const [timelineDataKursi, setTimelineDataKursi] = useState([]);
    // const [timelineData, setTimelineData] = useState([]);
    const [DummytimelineData, setDummytimelineData] = useState([]);

    const [loadingChart, setLoadingChart] = useState(true);
    // const [deviceVelocity, setdeviceVelocity] = useState([]);
    const [deviceKeys, setDeviceKeys] = useState(() => {
        // let map = new Map();
        // Array.from(areas).forEach((area) => {
        //   Array.from(area.devices).forEach((device) => {
        //     map.set(device.deviceId, device.name);
        //   });
        // });
        // let devices = [...map.keys()].reverse();
        let devices = ["entering", "leaving"];
        return devices;
    });
    const [sum, setSum] = useState(0);
    const [tsinberiSum, setTsinberiSum] = useState(0);
    const [ShikmimSum, setShikmimSum] = useState(0);
    const [kursiSum, setKursiSum] = useState(0);
    const [compareSum, setCompareSum] = useState(0);
    const [compareSumTsinberi, setCompareSumTsinberi] = useState(0);
    const [compareSumShikmim, setCompareSumShikmim] = useState(0);
    const [compareSumKursi, setCompareSumKursi] = useState(0);
    const [totaloccupancy, settotaloccupancy] = useState(0);
    const [total, setTotal] = useState(0);
    const [dataTest, setDataTest] = new useState([]);
    const [dataByDuration, setDataByDuration] = useState([]);
    const [lineDataByDuration, setLineDataByDuration] = useState([]);
    const [occupancylineDataByDuration, setOccupancyLineDataByDuration] = useState([]);
    const [vacancyValue, setVacancyValue] = useState([]);
    const [donutDataByDuration, setDonutDataByDuration] = useState([]);
    const { config } = useConfig();
    const deviceMap = new Map();
    let DeviceNames = ["KURSI_BEACH", "TSINBERI", "SHIKMIM"]/* config.areas.map(el => {
        // let area = el.area.replace("_"," ")
        deviceMap.set(el.area, el.devices.map(d => d.deviceId));
        return el.area;
        }); */
    const [lineDeviceName, setLineDeviceName] = useState(DeviceNames[0]);
    const [occupancyLineDeviceName, setOccupancyLineDeviceName] = useState(DeviceNames[0]);
    const [donutDeviceName, setDonutDeviceName] = useState(DeviceNames[0]);
    const colors = ["#55b8ba", "#6363FF"];
    const svgColors = ["#55b8ba", "#6363FF"];
    const colorTexts = [
        "text-cyan-700",
        "text-blue-700",
        "text-purple-400",
        "text-green-700",
    ];
    const [loadingBalance, setLoadingBalance] = useState(true);
    const textDescription = ["Entering", "Leaving"];
    const textChartDescription = ["Kineret 1 ", "Kineret 2 "];
    let stateData = [
        // timelineData
        timelineDataTsinberi,
        timelineDataShikmim,
        timelineDataKursi,
    ];
    let sumstateData = [compareSumTsinberi, compareSumShikmim, compareSumKursi];
    // console.log(config.areas, "config.areas");
    // console.log(compareSum, "compareSum--");
    // console.log(tsinberiSum, ShikmimSum, "show sum");
    let dummyOtherDeviceData = [
        {
            date: "2023-09-25T21:00:31.587Z",
            day: 25,
            deviceId: "600a0c2a69e85088",
            hour: "21:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 21,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695675600000,
            totalCount: 7,
            vehiclesCount: 7,
            year: 2023,
            _id: "6511f4f461ae4b00b1cb9316",
        },

        {
            date: "2023-09-25T22:51:24.709Z",
            day: 25,
            deviceId: "600a0c2a69e85088",
            hour: "22:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 22,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695679200000,
            totalCount: 1,
            vehiclesCount: 1,
            year: 2023,
            _id: "65120eec61ae4b00b1cb9318",
        },

        {
            date: "2023-09-25T23:14:09.973Z",
            day: 25,
            deviceId: "600a0c2a69e85088",
            hour: "23:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 23,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695682800000,
            totalCount: 1,
            vehiclesCount: 1,
            year: 2023,
            _id: "6512144261ae4b00b1cb931a",
        },

        {
            date: "2023-09-26T00:19:19.682Z",
            day: 26,
            deviceId: "600a0c2a69e85088",
            hour: "0:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 0,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695686400000,
            totalCount: 4,
            vehiclesCount: 4,
            year: 2023,
            _id: "6512238761ae4b00b1cb931c",
        },

        {
            date: "2023-09-26T03:39:48.952Z",
            day: 26,
            deviceId: "600a0c2a69e85086",
            hour: "3:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 3,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695697200000,
            totalCount: 4,
            vehiclesCount: 4,
            year: 2023,
            _id: "6512528b61ae4b00b1cb931e",
        },

        {
            date: "2023-09-26T04:02:15.359Z",
            day: 26,
            deviceId: "600a0c2a69e85086",
            hour: "4:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 4,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695700800000,
            totalCount: 5,
            vehiclesCount: 5,
            year: 2023,
            _id: "651258f061ae4b00b1cb9324",
        },

        {
            date: "2023-09-26T05:44:44.307Z",
            day: 26,
            deviceId: "600a0c2a69e85086",
            hour: "5:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 5,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695704400000,
            totalCount: 2,
            vehiclesCount: 2,
            year: 2023,
            _id: "65126fd461ae4b00b1cb932a",
        },
        {
            date: "2023-09-26T06:00:32.428Z",
            day: 26,
            deviceId: "600a0c2a69e85086",
            hour: "6:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 6,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695708000000,
            totalCount: 12,
            vehiclesCount: 12,
            year: 2023,
            _id: "6512738b61ae4b00b1cb932c",
        },
    ];
    // console.log(dummyOtherDeviceData.length, "show the dummyOtherDeviceData");
    function getDeviceNames() {
        let map = new Map();

        Array.from(areas).forEach((area) => {
            Array.from(area.devices).forEach((device) => {
                map.set(device.deviceId, device.name);
            });
        });
        let devices = ["entering", "leaving"];

        setDeviceKeys((prev) => devices);
        // setDeviceKeys((prev) => [...map.keys()]);
    }

    // function testDataTimeLine() {
    //   let data = [];
    //   let hour = new Date().getHours();

    //   for (let index = 0; index < deviceKeys.length; index++) {
    //     const device = deviceKeys[index];
    //     for (let index = hour; index > 0; index--) {
    //       let date = new Date();
    //       date.setHours(index);
    //       let id = device.slice(10);
    //       let keys = [`entering-${id}`, `leaving-${id}`];
    //       let obj = {
    //         deviceId: device,
    //         hour: getLocalHour(date),
    //         keys: keys,
    //         [device]: Math.floor(Math.random() * 500),
    //       };
    //       data.push(obj);
    //     }
    //   }
    //   // data = margeSameHours(data);
    //   // data = fillLine(data);
    //   // setTimelineData((prev) => data);
    //   setTimelineData((prev) => data);
    //   setLoadingChart(false);
    // }
    // console.log(deviceKeys, "show deviceKeys");
    // function updateTimelineData() {
    //     if (request_updateTimelineData_safe === false) {
    //         return;
    //     } else {
    //         request_updateTimelineData_safe = false;
    //     }
    //     axios
    //         .get(
    //             `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
    //                 new Date().getUTCMonth() + 1
    //             }&areas=${null}`
    //         )
    //         .then((res) => {
    //             //kursi beach data
    //             let resData = [];
    //             let leaving = 0;
    //             let entering = 0;
    //             let fakeData = [];
    //             //tsinberi Data
    //             let tsinberiData = [];
    //             let leavingTsinberi = 0;
    //             let enteringTsinberi = 0;
    //             //shikmim data
    //             let shikmimData = [];
    //             let leavingshikmim = 0;
    //             let enteringshikmim = 0;
    //             //Kursi beach original Data
    //             let kursiData = [];
    //             let leavingKursi = 0;
    //             let enteringKursi = 0;
    //             // let dummyresData = [];
    //             let data = res.data.flat();
    //             //         const result = {};
    //             // const encounteredHours = new Set();

    //             // for (const item of data) {
    //             //   const { hour, deviceId } = item;
    //             //   const hourDeviceKey = `${hour}-${deviceId}`;

    //             //   if (!encounteredHours.has(hour)) {
    //             //     result[hour] = {};
    //             //     result[hour][deviceId] = item;
    //             //     encounteredHours.add(hour);
    //             //   } else if (!result[hour][deviceId]) {
    //             //     result[hour][deviceId] = item;
    //             //   }
    //             // }

    //             // const finalResult = Object.values(result).flatMap((hourData) =>
    //             //   Object.values(hourData)
    //             // );
    //             const result = {};
    //             const encounteredCombinations = new Set();

    //             for (const item of data) {
    //                 const { hour, deviceId } = item;
    //                 const combinationKey = `${hour}-${deviceId}`;

    //                 if (!encounteredCombinations.has(combinationKey)) {
    //                     if (!result[hour]) {
    //                         result[hour] = {};
    //                     }
    //                     if (!result[hour][deviceId]) {
    //                         result[hour][deviceId] = [];
    //                     }
    //                     if (result[hour][deviceId].length < 4) {
    //                         result[hour][deviceId].push(item);
    //                         encounteredCombinations.add(combinationKey);
    //                     }
    //                 }
    //             }

    //             const finalResult = Object.values(result).flatMap((hourData) =>
    //                 Object.values(hourData).flatMap((deviceData) => deviceData)
    //             );

    //             // console.log(finalResult);

    //             // console.log(finalResult,"show final resultttt");
    //             // console.log(data.length, "show the response data length");
    //             // console.log(data, "show the response data ");
    //             let devicCHeck = data.filter((d, k) => {
    //                 return d.deviceId === "600a0c2a69e8508a" ||
    //                     d.deviceId === "600a0c2a69e85084"
    //                     ? d.deviceId
    //                     : null;
    //             });
    //             // console.log(devicCHeck, "devicCHeck");

    //             //kursi data
    //             // for (let j = 0; j < data.length; j++) {
    //             //   // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //             //   let deviceId = data[j]["deviceId"];
    //             //   let hour = new Date(data[j]["date"]).getHours();
    //             //   console.log(deviceId, hour, "deviceId,hour");
    //             //   // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //             //   if (hour <= new Date().getHours()) {
    //             //     console.log(hour, "less hour");
    //             //     console.log(deviceId.slice(10), "deviceId.slice(10)");
    //             //     let id = deviceId.slice(10);
    //             //     let keys = [`entering-${id}`, `leaving-${id}`];
    //             //     let obj = {
    //             //       deviceId: deviceId,
    //             //       hour: getLocalHour(data[j]["date"]),
    //             //       keys: keys,
    //             //       leaving:
    //             //         deviceId === "600a0c2a69e812dc" ||
    //             //         deviceId === "600a0c2a69e816d8"
    //             //           ? data[j]["vehiclesCount"] + data[j]["otherCount"]
    //             //           : 0,
    //             //       entering:
    //             //         deviceId === "600a0c2a69e811c8" ||
    //             //         deviceId === "600a0c2a69e816da"
    //             //           ? data[j]["vehiclesCount"] + data[j]["otherCount"]
    //             //           : 0,
    //             //       total: data[j]["vehiclesCount"] + data[j]["otherCount"],
    //             //     };
    //             //     if (
    //             //       deviceId === "600a0c2a69e811c8" ||
    //             //       deviceId === "600a0c2a69e816da"
    //             //     ) {
    //             //       entering += data[j]["vehiclesCount"] + data[j]["otherCount"];
    //             //     } else {
    //             //       leaving += data[j]["vehiclesCount"] + data[j]["otherCount"];
    //             //     }
    //             //     resData.push(obj);
    //             //   }
    //             // }
    //             //tsinberi data
    //             for (let j = 0; j < finalResult.length; j++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[j]["deviceId"];
    //                 if (deviceId === "600a0c2a69e85088") {
    //                     fakeData.push(finalResult[j]["vehiclesCount"]);
    //                 }
    //                 // console.log(fakeData,"show the Fake Data")
    //                 let hour = new Date(finalResult[j]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[j]["day"] === currentDay) {
                        
                    
    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${id === "600a0c2a69e85086" ? id : null}`,
    //                         `leaving-${id === "600a0c2a69e85088" ? id : null}`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceId === "600a0c2a69e85086" ||
    //                             deviceId === "600a0c2a69e85088"
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[j]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             deviceId === "600a0c2a69e85088"
    //                                 ? finalResult[j]["outCount"]
    //                                 : // + data[j]["otherCount"]
    //                                   0,
    //                         entering:
    //                             deviceId === "600a0c2a69e85086"
    //                                 ? finalResult[j]["inCount"]
    //                                 : // + data[j]["otherCount"]
    //                                   0,
    //                         total:
    //                             finalResult[j]["vehiclesCount"] +
    //                             finalResult[j]["otherCount"],
    //                     };
    //                     if (deviceId === "600a0c2a69e85086") {
    //                         enteringTsinberi += finalResult[j]["inCount"];
    //                         // + data[j]["otherCount"];
    //                     } else if (deviceId === "600a0c2a69e85088") {
    //                         leavingTsinberi += finalResult[j]["outCount"];
    //                         // + data[j]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {
                            
    //                         tsinberiData.push(obj);
    //                     // }
    //                 }
    //             // }
    //             }

    //             //shikmim data
    //             for (let k = 0; k < finalResult.length; k++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[k]["deviceId"];
    //                 if (
    //                     deviceId === "600a0c2a69e85084" ||
    //                     deviceId === "600a0c2a69e8508a"
    //                 ) {
    //                     // console.log(deviceId, "show checked deviceId");
    //                 }
    //                 // console.log(deviceId, "show all deviceod888");
    //                 let hour = new Date(finalResult[k]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[k]["day"] === currentDay) {
    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${id === "600a0c2a69e85084" ? id : null}`,
    //                         `leaving-${id === "600a0c2a69e8508a" ? id : null}`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceId === "600a0c2a69e85084" ||
    //                             deviceId === "600a0c2a69e8508a"
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[k]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             deviceId === "600a0c2a69e8508a"
    //                                 ? finalResult[k]["outCount"]
    //                                 : // + data[k]["otherCount"]
    //                                   0,
    //                         entering:
    //                             deviceId === "600a0c2a69e85084"
    //                                 ? finalResult[k]["inCount"]
    //                                 : //  + data[k]["otherCount"]
    //                                   0,
    //                         total:
    //                             finalResult[k]["vehiclesCount"] +
    //                             finalResult[k]["otherCount"],
    //                     };
    //                     if (deviceId === "600a0c2a69e85084") {
    //                         // console.log(deviceId,"show the de----===")
    //                         enteringshikmim += finalResult[k]["inCount"];
    //                         // + data[k]["otherCount"];
    //                     } else if (deviceId === "600a0c2a69e8508a") {
    //                         leavingshikmim += finalResult[k]["outCount"];
    //                         // + data[k]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {
    //                     shikmimData.push(obj);
    //                     // }
    //                 }
    //             // }
    //             }

    //             //kursi data
    //             for (let l = 0; l < finalResult.length; l++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[l]["deviceId"];
    //                 if (
    //                     deviceId === "600a0c2a69e812dc" ||
    //                     deviceId === "600a0c2a69e808f0"
    //                 ) {
    //                     fakeData.push(finalResult[l]["vehiclesCount"]);
    //                 }
    //                 // console.log(fakeData,"show the Fake Data")
    //                 let hour = new Date(finalResult[l]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[l]["day"] === currentDay) {
    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${
    //                             id === "600a0c2a69e816da" ||
    //                             id === "600a0c2a69e811c8"
    //                                 ? id
    //                                 : null
    //                         }`,
    //                         `leaving-${
    //                             id === "600a0c2a69e812dc" ||
    //                             id === "600a0c2a69e808f0"
    //                                 ? id
    //                                 : null
    //                         }`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceId === "600a0c2a69e816da" ||
    //                             deviceId === "600a0c2a69e812dc" ||
    //                             deviceId === "600a0c2a69e811c8" ||
    //                             deviceId === "600a0c2a69e808f0"
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[l]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             deviceId === "600a0c2a69e812dc" ||
    //                             deviceId === "600a0c2a69e808f0"
    //                                 ? finalResult[l]["vehiclesCount"]
    //                                 : // + data[j]["otherCount"]
    //                                   0,
    //                         entering:
    //                             deviceId === "600a0c2a69e816da" ||
    //                             deviceId === "600a0c2a69e811c8"
    //                                 ? finalResult[l]["vehiclesCount"]
    //                                 : // + data[j]["otherCount"]
    //                                   0,
    //                         total:
    //                             finalResult[l]["vehiclesCount"] +
    //                             finalResult[l]["otherCount"],
    //                     };
    //                     if (
    //                         deviceId === "600a0c2a69e816da" ||
    //                         deviceId === "600a0c2a69e811c8"
    //                     ) {
    //                         enteringKursi += finalResult[l]["vehiclesCount"];
    //                         // + data[j]["otherCount"];
    //                     } else if (
    //                         deviceId === "600a0c2a69e812dc" ||
    //                         deviceId === "600a0c2a69e808f0"
    //                     ) {
    //                         leavingKursi += finalResult[l]["vehiclesCount"];
    //                         // + data[j]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {
    //                     kursiData.push(obj);
    //                     // }
    //                 }
    //             // }
    //             }
    //             // console.log(shikmimData, "show the shimimmmmmmmmmmmmmmm");
    //             // console.log(tsinberiData, "show the tsinberiiiiiiiiiiiiiii");
    //             // console.log(kursiData,"show the kursiiiiiiiiiiiii");

    //             // console.log(entering, leaving, "entering,leaving,");
    //             let enterLeaving = entering - leaving;
    //             // console.log(enterLeaving, "enterLeaving");
    //             let dailySum = entering - leaving + sum;
    //             let TotalTsinberi = enteringTsinberi - leavingTsinberi;
    //             let totalShikmim = enteringshikmim - leavingshikmim;
    //             // console.log(
    //             //   TotalTsinberi / 13,
    //             //   totalShikmim / 13,
    //             //   "TotalTsinberi,totalShikmim========="
    //             // );
    //             // let tsinberidailySum = Math.round(TotalTsinberi / 13) + tsinberiSum;
    //             // let shikmimdailySum = Math.round(totalShikmim / 13) + ShikmimSum;
    //             //old occupancy calculation of Tsinberi and Shikmim
    //             // let tsinberidailySum = Math.round(TotalTsinberi / 13) + tsinberiSum;
    //             // let shikmimdailySum = Math.round(totalShikmim / 13) + ShikmimSum;
    //             // console.log(tsinberiSum,ShikmimSum,"jjjjjjjjjjj")

    //             // console.log(shikmimdailySum, "shikmimdailySum0090909");
    //             // console.log(tsinberidailySum, "tsinberidailySumtsinberidailySum");
    //             resData = margeSameHours(resData);
    //             tsinberiData = margeSameHours(tsinberiData);
    //             shikmimData = margeSameHours(shikmimData);
    //             kursiData = margeSameHours(kursiData);

    //             let tsinberiDataFinal = tsinberiData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             let shikmimDataFinal = shikmimData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             let kursiDataFinal = kursiData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             //new occupnacy calculation for Tsinberi and Shikmim
    //             let tsinberiCurrentCalculate = tsinberiDataFinal.reduce(
    //                 (a, b) => {
    //                     return (a += b.entering - b.leaving);
    //                 },
    //                 0
    //             );
    //             let shikmimCurrentCalculate = shikmimDataFinal.reduce(
    //                 (a, b) => {
    //                     return (a += b.entering - b.leaving);
    //                 },
    //                 0
    //             );
    //             let kursiCurrentCalculate = kursiDataFinal.reduce((a, b) => {
    //                 return (a += b.entering - b.leaving);
    //             }, 0);
    //             // console.log(shikmimCurrentCalculate,"shikmimCurrentCalculate")
    //             // console.log(tsinberiCurrentCalculate,"tsinberiCurrentCalculate")
    //             let tsinberidailySum = tsinberiCurrentCalculate + tsinberiSum;
    //             let shikmimdailySum = shikmimCurrentCalculate + ShikmimSum;
    //             let kursidailySum = kursiCurrentCalculate + kursiSum;
    //             // console.log(tsinberidailySum,shikmimdailySum,"showwwwww_bothh")
    //             //new occupancy calculation ends here
    //             // console.log(tsinberiDataFinal, "tsinberiDataFinal");
    //             //   console.log(tsinberiData,"0000000000000")
    //             //   console.log(resData, "show the resData");
    //             let totalOccupancy = resData.reduce((a, b) => {
    //                 return a + b.entering;
    //             }, 0);
    //             settotaloccupancy(totalOccupancy + sum);
    //             // console.log(totaloccupancy, "totalOccupancy");
    //             // resData = fillLine(resData, devices);
    //             // if (dailySum < 0) {
    //             //   dailySum = 5;
    //             // }
    //             // if (tsinberidailySum < 0) {
    //             //     tsinberidailySum = 5;
    //             // }
    //             // if (shikmimdailySum < 0) {
    //             //     shikmimdailySum = 5;
    //             // }
    //             // if (kursidailySum < 0) {
    //             //     kursidailySum = 5;
    //             // }
    //             setCompareSum((prev) => dailySum);
    //             setCompareSumTsinberi((prev) => tsinberidailySum);
    //             setCompareSumShikmim((prev) => shikmimdailySum);
    //             setCompareSumKursi((prev) => kursidailySum);
    //             setTimelineData((prev) => resData);
    //             setTimelineDataTsinberi((prev) => tsinberiDataFinal);
    //             setTimelineDataShikmim((prev) => shikmimDataFinal);
    //             setTimelineDataKursi((prev) => kursiDataFinal);
    //             setLoadingChart(false);
    //             request_updateTimelineData_safe = true;
    //             // for(let k=0;k<dummyOtherDeviceData.length;k++){
    //             //   let deviceId = dummyOtherDeviceData[k]["deviceId"];
    //             //   console.log(deviceId,"show the deviceId-=-=-=-")
    //             //   let hour = new Date(dummyOtherDeviceData[k]["date"]).getHours();
    //             //   console.log(deviceId,hour,"deviceId,hour")
    //             //   // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //             //   if (hour <= new Date().getHours()) {
    //             //     console.log(hour,"less hour")
    //             //     console.log(deviceId.slice(10),"deviceId.slice(10)")
    //             //     let id = deviceId.slice(10);
    //             //     let keys = [`entering-${id}`, `leaving-${id}`];
    //             //     let obj = {
    //             //       deviceId: deviceId,
    //             //       hour: getLocalHour(dummyOtherDeviceData[k]["date"]),
    //             //       keys: keys,
    //             //       leaving:
    //             //         deviceId === "600a0c2a69e85088"
    //             //           ? dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"]
    //             //           : 0,
    //             //       entering:
    //             //         deviceId === "600a0c2a69e85086"
    //             //           ? dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"]
    //             //           : 0,
    //             //       total: dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"],
    //             //     };
    //             //     console.log(obj,"show obj-----")
    //             //     // if (
    //             //     //   deviceId === "600a0c2a69e811c8" ||
    //             //     //   deviceId === "600a0c2a69e816da"
    //             //     // ) {
    //             //     //   entering += data[k]["vehiclesCount"] + data[k]["otherCount"];
    //             //     // } else {
    //             //     //   leaving += data[k]["vehiclesCount"] + data[k]["otherCount"];
    //             //     // }
    //             //     dummyresData.push(obj);
    //             //   }
    //             // }
    //             // setDummytimelineData((prev)=>dummyresData)
    //         })
    //         .catch((err) => {
    //             console.log(
    //                 "error with get hour statistic inside today vehicles-> ",
    //                 err
    //             );
    //             request_updateTimelineData_safe = true;
    //         });
    // }
    // function updateBalance() {
    //     // console.log(request_updateTimelineData_safe);
    //     if (request_updateTimelineData_safe === false) {
    //         return;
    //     } else {
    //         request_updateTimelineData_safe = false;
    //     }
    //     axios.get(`/v1/balance?token=${token}`).then((res) => {
    //         let data = res.data.flat();
    //         data = data.sort((a, b) => {
    //             return (
    //                 new Date(b["date"]).getTime() -
    //                 new Date(a["date"]).getTime()
    //             );
    //         });
    //         let TsinberiDataSum = [];
    //         let ShikmimDataSum = [];
    //         let KursiDataSum = [];

    //         data.map((da, k) => {
    //             if (da.deviceId === "600a0c2a69e85088") {
    //                 return TsinberiDataSum.push(da.sum);
    //             } else if (da.deviceId === "600a0c2a69e8508a") {
    //                 return ShikmimDataSum.push(da.sum);
    //             } else if (da.deviceId === "600a0c2a69e811c8") {
    //                 return KursiDataSum.push(da.sum);
    //             }
    //         });
    //         // console.log(TsinberiDataSum,"TsinberiDataSumTsinberiDataSum")
    //         // console.log(ShikmimDataSum,"ShikmimDataSumShikmimDataSum")

    //         // console.log(data,"balance sort data")
    //         let sum = data[0]["sum"];
    //         setTsinberiSum(TsinberiDataSum[0]);
    //         setShikmimSum(ShikmimDataSum[0]);
    //         setKursiSum(KursiDataSum[0]);
    //         // console.log(TsinberiDataSum[0],ShikmimDataSum[0],"show both")
    //         if (tsinberiSum > 0) {
    //             setLoadingBalance(false);
    //         }
    //         if (kursiSum > 0) {
    //             setLoadingBalance(false);
    //         }
    //         // console.log(data,"show the balance data++++")
    //         // console.log(sum,"show the sum coorectly")
    //         // console.log("finished balance");
    //         request_updateTimelineData_safe = true;
    //         setSum((prev) => sum);
    //     });
    // }

    function updateTimeBasedData(date) {
        // console.log(date, "show t2he date");
        date.to = endOfDay(date.to);
        // console.log(date, "show t2he date");
        Promise.all(DeviceNames.map(deviceName => axios.get(`/v1/temp/deviceTest/text/test?dateRangeFrom=${date.from}&dateRangeTo=${date.to}&location=${deviceName}`))).then(([{ data: kursi }, { data: tsinberi }, { data: shikmim }]) => setDataByDuration([kursi, tsinberi, shikmim])).catch(err => console.error(err));
        // axios.get(`/v1/temp/deviceTest/text/test?dataDuration=${dataDuration}&location=${deviceName}`).then(res => setDataByDuration(res.data.result)).catch(err => console.error(err))
    }

    function updateTimeBasedLineData() {
        // console.log(loader,"oneLoader"); 
        // setTimeout(()=>{
        //     console.log("timOut");            
        // },9000)
        axios.get(`/v1/temp/deviceTest/text/test?dataDuration=7D&location=${lineDeviceName}`).then(res => setLineDataByDuration(res.data.result)).catch(err => console.error(err))
    }

    function updateTimeBasedOccupancyLineData() {
        // console.log(loader,"oneLoader"); 
        // setTimeout(()=>{
        //     console.log("timOut");            
        // },9000)
        axios.get(`/v1/statistics/kinneretOccupancy?dataDuration=7D&location=${occupancyLineDeviceName}`).then(res => setOccupancyLineDataByDuration(res.data.result)).catch(err => console.error(err))
    }

    function getAllVacancy() {
        Promise.all(DeviceNames.map(deviceName => axios.get(`/v1/temp/deviceTest/text/piTest?location=${deviceName}`)))
            .then(([{ data: ahadHaam }, { data: sanMartin }, { data: zvi }]) => setVacancyValue([ahadHaam, sanMartin+zvi]));
    }

    function updateTimeBasedDonutData() {
        axios.get(`/v1/temp/deviceTest/text/test?dataDuration=21D&location=${donutDeviceName}`).then(res => {setDonutDataByDuration(res.data.result); setLoadingChart(false)}).catch(err => console.error(err))
    }

    // console.log(compareSum, "show the compare sum ");
    // console.log(DummytimelineData, "show the DummytimelineData ");
    // console.log(timelineDataTsinberi, "show the timelineDataTsinberi ");
    // console.log(timelineDataShikmim, "show the timelineDataShikmim ");
    // let tsinberiCurrentCalculate=timelineDataTsinberi.reduce((a,b)=>{
    //   return a+=b.entering-b.leaving
    // },0)
    // let shikmimCurrentCalculate=timelineDataShikmim.reduce((a,b)=>{
    //   return a+=b.entering-b.leaving
    // },0)
    // console.log(tsinberiCurrentCalculate,"tsinberiCurrentCalculate")
    useEffect(() => {
        // updateTimelineData();
        // console.log(request_updateTimelineData_safe);
        getAllVacancy();
        getDeviceNames();
        // updateBalance();
        // updateTimelineData();
        // setTimeout(() => {
        //   testDataTimeLine();
        // }, 5000);

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request_updateTimelineData_safe]);

    useEffect(() => {
        updateTimeBasedLineData();
    },[lineDeviceName])

    useEffect(() => {
        updateTimeBasedOccupancyLineData();
    },[occupancyLineDeviceName])

    useEffect(() => {
        updateTimeBasedDonutData();
    },[donutDeviceName])

    // Get the up-to-date data for the in-out chart every 1 sec
    useInterval(
        () => {
            // updateTimelineData();
            return () => {};
        },
        loadingChart ? 1000 : 10000,
        true
    );
    useInterval(
        () => {
            // updateBalance();
            updateTimeBasedLineData();
            updateTimeBasedDonutData();
            getAllVacancy();
            return () => {};
        },
        10000,
        true
    );
    let empArray = [1, 2, 3];
    // let DeviceNames = ["חוף צינברי", "חוף שיקמים", "חוף כורסי"];

    const totalParkingSpaces = [1440, 810/* , 405 */];

    if (loadingChart) {
        return (
            <>
                {/* <div className="flex w-full gap-2 h-[100%]">
                    <div
                        className="flex flex-col gap-2"
                        style={{ width: "50%" }}
                    >
                        <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                        <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                        <div className="bg-gray-300  w-[200%] px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                    </div>
                    <div
                        className="flex flex-col gap-2"
                        style={{ width: "50%" }}
                    >
                        <div className="flex justify-center h-[33.33%] gap-2">
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[50%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                        </div>
                        <div className="flex justify-center h-[32%]">
                            <div className="bg-gray-300  w-full px-4 rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                        </div>

                    </div>
                </div> */}
                <div className="flex flex-col lg:flex-row lg:flex-wrap">
                    <div className="w-full mb-4 lg:mb-0">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                        <div className="p-1 text-center"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>
                </div>
            </>
        );
    }


    // console.log(compareSum, "compareSum==compareSum");
    // if (loadingChart) {
    //     return (
    //         <>
    //             <div className="flex w-full gap-2 h-[100%]">
    //                 <div
    //                     className="flex flex-col gap-2"
    //                     style={{ width: "50%" }}
    //                 >
    //                     <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
    //                         <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                     </div>
    //                     <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
    //                         <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                     </div>
    //                     <div className="bg-gray-300  w-[200%] px-4 h-[50%] rounded-md overflow-hidden transition-all">
    //                         <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                     </div>
    //                 </div>
    //                 <div
    //                     className="flex flex-col gap-2"
    //                     style={{ width: "50%" }}
    //                 >
    //                     <div className="flex justify-center h-[33.33%] gap-2">
    //                         <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
    //                             <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                         </div>
    //                         <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
    //                             <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                         </div>
    //                         <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
    //                             <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                         </div>
    //                         <div className="bg-gray-300  w-[50%] px-4  rounded-md overflow-hidden transition-all">
    //                             <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                         </div>
    //                     </div>
    //                     <div className="flex justify-center h-[32%]">
    //                         <div className="bg-gray-300  w-full px-4 rounded-md overflow-hidden transition-all">
    //                             <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
    //                         </div>
    //                     </div>
                        
    //                 </div>
    //             </div>
    //         </>
    //     );
    // }
    // return (
    //   <div
    //     className="flex flex-row justify-evenly"
    //     style={{ justifyContent: "end" }}
    //   >
    //     <YsbMainMap
    //       areas={config.areas[0]}
    //       // token={auth.token}
    //       mapConfig={config.map}
    //       colors={colors}
    //       shape="CIRCLES"
    //       // onClickHandler={clickEventHandler}
    //       buttonDesc="לצפייה בהכל לחץ כאן"
    //       // onAllClickHandler={clickEventAllHandler}
    //     />
    //     <div className="flex flex-col h-full w-4/12 justify-around px-2 chart-section">
    //       {DeviceNames.length > 0 &&
    //         DeviceNames.map(
    //           (value, index) => (
    //             <div
    //               key={deviceKeys.at(index)}
    //               className={`text-center flex flex-col mb-2  rounded-xl  bg-slate-50 p-3 `}
    //               style={{
    //                 border: "1.5px solid black",
    //                 // marginBottom: `${index === 0 ? "1rem" : "unset"}`,
    //               }}
    //             >
    //               <div className=" text-center flex w-full h-full flex-col justify-items-center justify-center chart-card-block">
    //                 {/* <div className=" font-bold ">
    //                   {textChartDescription[index]}
    //                 </div> */}
    //                 <div
    //                   className="flex flex-row items-center justify-end"
    //                   key={index}
    //                 >
    //                   <div
    //                     className="w-100 rounded-lg chart-width"
    //                     // key={deviceKeys.at(index) + "1"}
    //                   >
    //                     <h1
    //                       className="text-center"
    //                       style={{
    //                         fontSize: "1.5rem",
    //                         textAlign: "center",
    //                         marginLeft: "89px",
    //                         fontWeight: "600",
    //                       }}
    //                     >
    //                       {DeviceNames[index]}
    //                     </h1>
    //                     {/* <div>
    //                       <SvgComponent
    //                         key={deviceKeys.at(index) + index}
    //                         description={[textDescription[index]]}
    //                         svgColor={svgColors[index]}
    //                         textColor={colorTexts[index]}
    //                       />
    //                     </div> */}
    //                     <div>
    //                       {console.log(timelineData, "timelineProp")}
    //                       {console.log(stateData[index],deviceKeys.at(index), "proop")}
    //                       <LineChartComponent
    //                         key={deviceKeys.at(index) + index + index}
    //                         index={index}
    //                         // device={deviceKeys.at(index)}
    //                         device={deviceKeys.at(index)}
    //                         data={stateData[index]}
    //                         colorGraph={colors}
    //                         colorText={colorTexts}
    //                         textDescription={textChartDescription[index]}
    //                         isCustomTooltip={true}
    //                       />
    //                     </div>
    //                   </div>
    //                   {/* {types.length > 0 && (
    //               // hourly component
    //                 )} */}
    //                   {/* //components  */}
    //                   <div className="h-half 2xl:w-4/12 xl:w-4/12 lg:w-4/12 md:w-4/12 sm:w-4/12 mt-2 bg-bottom bg-slate-300 bg-blue bg-no-repeat bg-blend-screen  rounded-xl justify-items-center  text-indigo-500  justify-center items-center text-center font-bold text-xl ">
    //                     <div className="align-text-top">תפוסה נוכחית</div>
    //                     <div
    //                       className=" flex flex-col bg-transparent rounded-3xl  items-center "
    //                       style={{
    //                         paddingTop: "2.5rem",
    //                         paddingBottom: "2.5rem",
    //                       }}
    //                     >
    //                       <div className="text-white  flex text-center bg-blue-600 rounded-full p-4  ">
    //                         <div className="text-center flex">
    //                           {sumstateData[index]}
    //                         </div>
    //                       </div>
    //                       {/* <div className="text-white  flex text-center bg-blue-600 rounded-full p-4 flex-col ">
    //                         <p className="text-center" >Total occupancy</p>
    //                         <div className="text-center flex justify-content-center">{totaloccupancy+sum}</div>
    //                       </div> */}
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           ),
    //           [deviceKeys]
    //         )}
    //     </div>
    //     {/* <div className="h-full w-1/5 mt-2 bg-bottom bg-slate-300 bg-blue bg-no-repeat bg-blend-screen  rounded-xl justify-items-center  text-indigo-500  justify-center items-center text-center font-bold text-xl ">
    //       <div className="align-text-top">Occupancy</div>
    //       <div className="py-32 flex flex-col bg-transparent rounded-3xl  items-center ">
    //         <div className="text-white  flex text-center bg-blue-600 rounded-full p-4  ">
    //           <div className="text-center flex">{compareSum}</div>
    //         </div>
    //       </div>
    //     </div> */}
    //     {/* <div className=" bg-blue w-full bg-no-repeat"></div> */}
    //   </div>
    // );

    return (
        <div className="flex flex-col lg:flex-row lg:flex-wrap">
            <div className="w-full lg:w-2/3 mb-4 lg:mb-0">
                <div className="p-1"><YsbBarChart deviceNames={DeviceNames} dataByDuration={dataByDuration} updateTimeBasedData={updateTimeBasedData} /></div>
            </div>

            <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                <div className="p-1 text-center"><YsbLineChartOccupancy data={occupancylineDataByDuration} deviceNames={DeviceNames} lineDeviceName={occupancyLineDeviceName} setLineDeviceName={setOccupancyLineDeviceName} /></div>
            </div>

            <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                <div className="p-1 text-center"><YsbLineChart data={lineDataByDuration} deviceNames={DeviceNames} lineDeviceName={lineDeviceName} setLineDeviceName={setLineDeviceName} /></div>
            </div>

            <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                <div className="p-1"><YsbRadialChart totalParkingSpaces={totalParkingSpaces} vacancyValues={vacancyValue} deviceNames={DeviceNames} getAllVacancy={getAllVacancy} /></div>
            </div>

            <div className="w-full lg:w-1/3">
                <div className="p-1"><YsbDonutChart data={donutDataByDuration} deviceNames={DeviceNames} donutDeviceName={donutDeviceName} setDonutDeviceName={setDonutDeviceName} /></div>
            </div>
        </div>
        // <div className="mainBoard">
        //     <div className="primBlocks">
        //         <div className="secBlocks lineGraphArea">
        //             <ApexLineChart
        //                 data={stateData[0]}
        //                 areaTitle={DeviceNames[0]}
        //             />
        //         </div>
        //         <div className="secBlocks">
        //             <h1 className="occupancyTitle">{DeviceNames[0]}</h1>
        //             <h1 className="currentOccupancy">תפוסה נוכחית</h1>
        //             <CountUp start={0} end={sumstateData[0]} delay={0}>
        //                 {({ countUpRef }) => (
        //                     <div className="occupancyCount">
        //                         <span ref={countUpRef} />
        //                     </div>
        //                 )}
        //             </CountUp>
        //         </div>
        //         <div className="secBlocks">
        //             <h1 className="occupancyTitle">{DeviceNames[1]}</h1>
        //             <h1 className="currentOccupancy">תפוסה נוכחית</h1>
        //             <CountUp start={0} end={sumstateData[1]} delay={0}>
        //                 {({ countUpRef }) => (
        //                     <div className="occupancyCount">
        //                         <span ref={countUpRef} />
        //                     </div>
        //                 )}
        //             </CountUp>
        //         </div>
        //         <div className="secBlocks">
        //             <h1 className="occupancyTitle">{DeviceNames[2]}</h1>
        //             <h1 className="currentOccupancy">תפוסה נוכחית</h1>
        //             <CountUp start={0} end={sumstateData[2]} delay={0}>
        //                 {({ countUpRef }) => (
        //                     <div className="occupancyCount">
        //                         <span ref={countUpRef} />
        //                     </div>
        //                 )}
        //             </CountUp>
        //         </div>
        //         <div className="secBlocks">
        //             <YsbMainMap
        //                 areas={config.areas[0]}
        //                 // token={auth.token}
        //                 mapConfig={config.map}
        //                 colors={colors}
        //                 shape="CIRCLES"
        //                 // onClickHandler={clickEventHandler}
        //                 buttonDesc="לצפייה בהכל לחץ כאן"
        //                 // onAllClickHandler={clickEventAllHandler}
        //             />
        //         </div>
        //     </div>
        //     <div className="primBlocks">
        //         <div className="secBlocksOne lineGraphArea">
        //             <ApexLineChart
        //                 data={stateData[1]}
        //                 areaTitle={DeviceNames[1]}
        //             />
        //         </div>
        //         <div className="secBlocksOne lineGraphArea">
        //             <ApexLineChart
        //                 data={stateData[2]}
        //                 areaTitle={DeviceNames[2]}
        //             />
        //         </div>
        //     </div>
        //     <div className="primBlocks">
        //         <div className="lineGraphArea">
        //             <ApexMultiBarChart
        //                 tsinberiData={stateData[0]}
        //                 shikmimData={stateData[1]}
        //                 kursiData={stateData[2]}
        //             />
        //         </div>
        //     </div>
        // </div>
    );
};

export default YsbCombinedComponents;
